import { render } from "./cert-manager.io.certificate.vue?vue&type=template&id=985d8f3c"
import script from "./cert-manager.io.certificate.vue?vue&type=script&lang=js"
export * from "./cert-manager.io.certificate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__